export default __webpack_public_path__ + "static/media/header-img.57eeb6cc.jpg";